import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashQuestionContentLayout({children}) {
    // Used in FlashQuestionContent to frame question content
    // in desktop mode

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"w-full h-[304px] min-h-[304px] flex items-start space-x-24 mt-24"}>
            {children}
        </div>
    );
}